import { MainAdminPermissions } from "./main-admin";

export class DeveloperPermissions extends MainAdminPermissions {}
